import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import { UPDATE_TASK } from "./actionTypes";
import { updateTaskSuccessful, updateTaskFailed } from "./actions";

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();

function* updateTask({ payload: { task, token, history } }) {
  try {
    yield call(
      tasksAPI.updateTask,
      task.taskCode,
      task.priority,
      task.workstationCandidates,
      task.estimatedDurationSeconds,
      task.rackCode,
      task.face,
      token
    );

    history.push("/tasks");
    yield put(updateTaskSuccessful("ok"));
  } catch (error) {
    console.log(error);
    yield put(updateTaskFailed(error));
  }
}

export function* watchTaskUpdate() {
  yield takeEvery(UPDATE_TASK, updateTask);
}

function* updateTaskSaga() {
  yield all([fork(watchTaskUpdate)]);
}

export default updateTaskSaga;
